import * as React from 'react';
import { FC } from 'react';

const Error: FC<{ error: string }> = ({ error }) => {
  if (!error.length) return null;

  return <div className="alert-error">{error}</div>;
};

export default Error;
